import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import SidebarManage from '../components/SidebarManage';
import SidebarHistoryUSB from '../components/SidebarHistoryUSB';
import '../styles/usbPage.css';

class USBPage extends React.Component {

    constructor() {
        super(...arguments);
        this.data = [
            { id: 0, text: 'C:' },
            { id: 1, text: 'D:' },
            { id: 2, text: 'N:' },
            { id: 3, text: 'W:' }
        ];
        this.state = {
            SidebarHistoryVisible: 0,
            SidebarManageVisible: 0
        };
    }

    selectDisks(e) {
        if (e.data.id === 0) { <div>{'sono c'}</div> }
        if (e.data.id === 1) { <div>{'sono D'}</div> }
        if (e.data.id === 2) { <div>{'sono N'}</div> }
        if (e.data.id === 3) { <div>{'sono W'}</div> }
    }

    openManageUSB() {
        if (this.state.SidebarManageVisible === 0) {
            this.setState({ SidebarManageVisible: 2 });
        }
        else {
            this.setState({ SidebarManageVisible: 0 });
        }
    }

    renderManageUSB() {
        if (this.state.SidebarManageVisible === 2)
            return (
                <div id='divBlockSideBarManageUSB'>
                    <SidebarManage
                        Option='USBPage'
                        SidebarManageVisible={this.state.SidebarManageVisible}
                        openManageUSB={this.openManageUSB.bind(this)} />
                </div>
            );
    }

    saveDataUSB() {
        <div><span>Data Save</span></div>
    }

    openHistoryUSB() {
        if (this.state.SidebarHistoryVisible === 0) {
            this.setState({ SidebarHistoryVisible: 1 });
        }
        else {
            this.setState({ SidebarHistoryVisible: 0 });
        }
    }

    renderHistoryUSB() {
        if (this.state.SidebarHistoryVisible === 1)
            return (
                <SidebarHistoryUSB
                    SidebarHistoryVisible={this.state.SidebarHistoryVisible}
                    openHistoryUSB={this.openHistoryUSB.bind(this)}
                />
            );
    }

    installProgram(e) {
        let sistOp;
        if (e === 1) sistOp = 'windows';
        if (e === 2) sistOp = 'linux_deb';
        if (e === 3) sistOp = 'linux_rpm';
        if (e === 4) sistOp = 'mac';
        { <div>{sistOp}</div> }
    }

    close() {
        this.props.HideUsb();
    }

    renderUSBPage() {

        return (
            <div id='divRenderUSB'>
                <div className='row'>
                    <div className='col-sm-9'></div>
                    <div className='col-sm-3' >
                        <ButtonComponent id='closeBtn' onClick={this.close.bind(this)}><FormattedMessage id='close' /></ButtonComponent>
                    </div>
                </div>
                <div id='availableDisks'>
                    <h1 id='titleDisks'><FormattedMessage id='disk_drive_available' /></h1>
                    <ListViewComponent id='list' dataSource={this.data}
                        fields={{ text: 'text' }} select={this.selectDisks.bind(this)}
                    ></ListViewComponent>

                </div>

                <div className='row' id='divBtnConfig'>
                    <div className='col-sm-6'>
                        <ButtonComponent id='btnConfig' onClick={this.openHistoryUSB.bind(this)}><FormattedMessage id='permission_history' /></ButtonComponent>
                    </div>
                    <div className='col-sm-6'>
                        <ButtonComponent id='btnConfig' onClick={this.openManageUSB.bind(this)}><FormattedMessage id='permission_manage' /></ButtonComponent>
                    </div>
                </div>

                <div className='row' id='divBtnSystemOp'>

                    <div className='col-sm-3'>
                        <div className='row' id='opSystem'>
                            <div className='col-sm-12'>
                                <img id='logoSystem' src={'/images/icons/windows.png'} />
                            </div>
                            <div className='col-sm-12'>
                                <ButtonComponent id='btnSystem' ref={system => this.system = system} onClick={() => this.installProgram(1)} iconCss='e-icons e-F_Download_usb' >Windows<p id='subTitle'>Windows 7, 8, 10</p></ButtonComponent>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='row' id='opSystem'>
                            <div className='col-sm-12'>
                                <img id='logoSystem' src={'/images/icons/linux.png'} />
                            </div>
                            <div className='col-sm-12'>
                                <ButtonComponent id='btnSystemLnx' ref={system => this.system = system} onClick={() => this.installProgram(2)} iconCss='e-icons e-F_Download_usb' >.deb<p id='subTitle'>Debian, Ubuntu</p></ButtonComponent>
                                <ButtonComponent id='btnSystemLnx' ref={system => this.system = system} onClick={() => this.installProgram(3)} iconCss='e-icons e-F_Download_usb' >.rpm<p id='subTitle'>Red hat, Fedora, SUSE</p></ButtonComponent>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <div className='row' id='opSystem'>
                            <div className='col-sm-12'>
                                <img id='logoSystem' src={'/images/icons/mac.png'} />
                            </div>
                            <div className='col-sm-12'>
                                <ButtonComponent id='btnSystem' ref={system => this.system = system} onClick={() => this.installProgram(4)} iconCss='e-icons e-F_Download_usb' >Mac<p id='subTitle'>macOS 10.10+</p></ButtonComponent>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );

    }

    render() {
        return (
            <div className='divBlockDialog'>
                <div className='dialogUSB'>
                    {this.renderHistoryUSB()}
                    {this.renderManageUSB()}
                    {this.renderUSBPage()}
                </div>
                <div className='e-dlg-overlay' />
            </div>
        );
    }

}
USBPage.propTypes = {
    intl: PropTypes.object,
    HideUsb: PropTypes.func
};

export default injectIntl(USBPage);